export class DomHelper {

    public static addCss(cssUrl: URL, cssId: string, frame?: { doc: Document; win: Window }) {
        const _document = frame?.doc || document;
        if (!_document.getElementById(cssId))
        {
            const head  = document.getElementsByTagName('head')[0];
            const link  = document.createElement('link');
            link.id   = cssId;
            link.href = cssUrl.toString();
            link.rel  = 'stylesheet';
            link.type = 'text/css';
            link.media = 'all';
            head.appendChild(link);
        }
    }

    public static addScript(scriptUrl: URL, scriptId: string, frame?: { doc: Document; win: Window }) {
        const _document = frame?.doc || document;
        const scriptElement = _document.getElementById(scriptId) ?? this.createScriptElement(scriptId, frame); 
        scriptElement.setAttribute('src', scriptUrl.toString());
    }

    public static createScriptElement(scriptId: string, frame?: { doc: Document; win: Window }) {
        const _document = frame?.doc || document;
        const scriptElement = _document.createElement("script");
        scriptElement.id = scriptId;
        scriptElement.defer = true;

        return scriptElement;
    }    
}